import { ISectionCTAsGroup } from "./ISectionCTAsGroup";
//for enablement of reordering facility within the sectionCTA group
export const reorderSectionCTA = (
  list: ISectionCTAsGroup.ISectionCTAs[],
  startIndex: number,
  endIndex: number,
) => {
  const result = Array.from(list || []);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
